import type { JSX } from 'react';
import React from 'react';
import { twMerge } from 'utilities/src/twMerge';

type CardCategoryProps = {
  children: JSX.Element;
  classes?: string;
};

function CardCategory({ children, classes }: CardCategoryProps) {
  return <span className={twMerge('site-paragraph-xs text-site-neutrals-400 mb-1', classes)}>{children}</span>;
}

export default CardCategory;
